<form [formGroup]="form" (ngSubmit)="sendFormData()">
  <h3><title mat-dialog-title>{{ 'map.createChannel.editChannel' | t }}</title></h3>

  <mat-dialog-content>
    <sn-slide-toggle class="publicity" formControlName="publicity">{{
      publicityControl.value ? ('map.createChannel.publicity.public' | t) : ('map.createChannel.publicity.private' | t)
    }}</sn-slide-toggle>
    <sn-slide-toggle class="hideSystemNotifications" formControlName="hideSystemNotifications"
      >{{ 'map.createChannel.hideSystemNotifications' | t }}</sn-slide-toggle
    >

    <mat-form-field class="mt-xs" appearance="fill">
      <mat-label>{{ 'common.name' | t }}</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="nameControl.hasError('required')">{{ 'common.nameRequired' | t }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button mat-button type="submit" color="success" [mtBasicSpinner]="isLoading">{{ 'common.update' | t }}</button>
  </mat-dialog-actions>
</form>
